module.exports = __webpack_public_path__ + "static/media/grab_singha1500-1.5eab80e9.jpg";